import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "color-options" }
const _hoisted_3 = ["onClick"]

import { ref, watch } from "vue";
import { Form } from "vee-validate";
import { Button, Icon, Input, Modal } from "@/components/ui";
import { useUpdateBucketOption } from "@/composables/bucket/useBucketOption";
import { useToast } from "@/composables/ui/useToast";

interface Props {
  selectedBucketOption: { id: string; name: string; colorHex: string } | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EditBucketOptionModal',
  props: {
    selectedBucketOption: {}
  },
  emits: ["closeEditBucketOptionModal", "refreshBucketOptions"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const $toast = useToast();

const { mutate: updateBucketOption, isPending: bucketOptionIsLoading } = useUpdateBucketOption();

const editBucketOptionObj = ref<{
  id: string | undefined;
  name: string | undefined;
  colorHex: string | undefined;
}>({
  id: undefined,
  name: undefined,
  colorHex: undefined,
});

const bucketColorOptions = [
  "#FA5A7D",
  "#FFD900",
  "#3CD856",
  "#3C3CFA",
  "#00A896",
  "#002B72",
  "#0005FF",
  "#7B003D",
  "#FF002C",
  "#DC00FD",
  "#2D0094",
  "#00AEFD",
  "#00FFAB",
  "#65A700",
];

function setValues(option: Props["selectedBucketOption"]) {
  if (!option) return;
  editBucketOptionObj.value.id = option.id;
  editBucketOptionObj.value.name = option.name;
  editBucketOptionObj.value.colorHex = option.colorHex;
}

function closeModal() {
  emit("closeEditBucketOptionModal");
}

function editBucketOption() {
  if (!editBucketOptionObj.value.colorHex) {
    $toast?.info("Please select a color");
    return;
  }

  updateBucketOption(
    {
      id: editBucketOptionObj.value.id!,
      name: editBucketOptionObj.value.name!,
      colorHex: editBucketOptionObj.value.colorHex,
    },
    {
      onSuccess: () => {
        emit("refreshBucketOptions");
        closeModal();
      },
      onError: (error: Error) => {
        $toast?.error(error.message || "Failed to update bucket");
      },
    }
  );
}

watch(
  () => props.selectedBucketOption,
  (v) => setValues(v),
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    show: true,
    size: "sm",
    headerVariant: "blue",
    closeOnBackdrop: false,
    blurBackdrop: false,
    backdropOpacity: 0.5,
    "show-close-button": false,
    onClose: closeModal
  }, {
    header: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bucket-header__text" }, [
        _createElementVNode("h2", { class: "bucket-header__title" }, "Edit Bucket"),
        _createElementVNode("p", { class: "bucket-header__subtitle" }, "Update bucket details")
      ], -1)),
      _createElementVNode("button", {
        type: "button",
        class: "bucket-header__close",
        onClick: closeModal,
        "aria-label": "Close"
      }, [
        _createVNode(_unref(Icon), {
          icon: "mdi:close",
          width: "18",
          height: "18"
        })
      ])
    ]),
    body: _withCtx(() => [
      _createVNode(_unref(Form), {
        id: "edit-bucket-form",
        class: "form-body",
        onSubmit: editBucketOption
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(Input), {
              modelValue: editBucketOptionObj.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editBucketOptionObj.value.name) = $event)),
              label: "Bucket Name",
              placeholder: "Enter Bucket Name",
              required: "",
              size: "md"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(bucketColorOptions, (color, index) => {
              return _createElementVNode("div", {
                key: index,
                class: "color-circle",
                style: _normalizeStyle({
              backgroundColor: color,
              boxShadow: editBucketOptionObj.value.colorHex === color ? '0 0 0 6px #E0E0E0' : 'none',
            }),
                onClick: ($event: any) => (editBucketOptionObj.value.colorHex = color)
              }, null, 12, _hoisted_3)
            }), 64))
          ])
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(Button), {
        variant: "secondary",
        size: "sm",
        onClick: closeModal
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Cancel", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        variant: "primary",
        size: "sm",
        type: "submit",
        form: "edit-bucket-form",
        loading: _unref(bucketOptionIsLoading),
        disabled: _unref(bucketOptionIsLoading)
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Save Changes ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    _: 1
  }))
}
}

})